import React from "react";

const Cupcake = props => (
  <svg viewBox="0 0 100 100" {...props}>
    <g fill="none" opacity={0.4}>
      <circle fillOpacity={0.8} fill="#4A4A4A" cx={50} cy={50} r={50} />
      <path
        d="M70.074 32.08L33.06 75.754l23.778 23.777C77.633 96.688 94.354 81.06 98.82 60.827L70.074 32.079z"
        fill="#4A4A4A"
      />
      <path
        d="M73.906 49.808l-6.062 24.247a4.058 4.058 0 0 1-3.936 3.074H36.092a4.057 4.057 0 0 1-3.936-3.074l-6.062-24.247h47.812z"
        fill="#EF717A"
      />
      <path
        d="M23.4 47.657c0-13.118 11.91-23.751 26.6-23.751 14.69 0 26.6 10.633 26.6 23.75 0 13.118-11.91 5.939-26.6 5.939-14.69 0-26.6 7.18-26.6-5.938z"
        fill="#F0DEB4"
      />
      <path
        d="M50 23.906c-14.602 0-26.45 10.507-26.593 23.516 2.399 1.123 4.96 1.76 7.401 1.905 14.141.336 28.283 0 43.098-2.694a8.96 8.96 0 0 0 2.59-1.003C75.343 33.462 63.925 23.906 50 23.906z"
        fill="#D5C295"
      />
      <circle fill="#C63C22" cx={50} cy={22.222} r={5.556} />
      <path
        d="M49.888 49.808v27.32h14.02a4.057 4.057 0 0 0 3.936-3.073l6.062-24.247H49.888z"
        fill="#D95459"
      />
      <path
        d="M50 23.906l-.112.002v29.688l.112-.001c14.69 0 26.6 7.18 26.6-5.938 0-13.118-11.91-23.751-26.6-23.751z"
        fill="#D8C49A"
      />
      <path
        d="M76.496 45.63C75.343 33.462 63.925 23.906 50 23.906l-.112.002V49.22c7.876-.334 15.844-1.1 24.018-2.586a8.96 8.96 0 0 0 2.59-1.003z"
        fill="#BAA479"
      />
      <path
        d="M50 16.667c-.038 0-.074.005-.112.005v11.1c.038 0 .074.006.112.006a5.555 5.555 0 1 0 0-11.111z"
        fill="#A52923"
      />
    </g>
  </svg>
);

export default Cupcake;



// WEBPACK FOOTER //
// ./src/components/Icons/Cupcake.js